import { usePopup } from '@/feature/alerts/components/PopupsProvider';

export const useModals = () => {
    const { closeLastPopUp, closeAllPopUps } = usePopup();
    return { dismiss: closeLastPopUp, dismissAll: closeAllPopUps };
};
